const r = "Appuyer sur Entrée pour modifier", e = {
  pressEnterToEdit: r
};
export {
  e as default,
  r as pressEnterToEdit
};
